const ajaxBtn = '.js-ajax-btn';

$(document).on('click', ajaxBtn, function(event) {
  event.preventDefault();

  const url = $(this).attr('href');

  $.ajax({
    url: url,
    dataType: 'html'
  })
    .done(function(response) {
      console.log(response);
      const $posts = $(response).find('.post');
      const $ajaxBtn = $(response).find(ajaxBtn);

      $('.posts').append($posts);

      $('.section-posts .section__actions')
        .empty()
        .append($ajaxBtn);
    })
    .fail(function() {
      console.log('error');
    });
});



// WEBPACK FOOTER //
// ./../src/assets/js/ajax-posts.js